import styled from 'styled-components'
import TSvgProps from './type/svgPropsType'

const CircularProgress = (props: TSvgProps) => {
  return (
    <StyledWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="22 22 44 44"
        aria-label="회전로딩"
      >
        <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth="3.6"></circle>
      </svg>
    </StyledWrapper>
  )
}

export default CircularProgress

const StyledWrapper = styled.i`
  @keyframes rotateProgress {
    0% {
      transform-origin: 50% 50%;
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes circularProgress {
    0% {
      stroke-dasharray: 1px, 200px;
      stroke-dashoffset: 0px;
    }
    50% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -15px;
    }
    100% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -125px;
    }
  }

  width: fit-content;
  height: fit-content;
  animation: rotateProgress 1.4s linear infinite;

  svg {
    display: block;

    circle {
      animation: circularProgress 1.4s ease-in-out infinite;
      stroke: currentColor;
      stroke-dasharray: 80px, 200px;
      stroke-dashoffset: 0px;
    }
  }
`
